module.exports = __webpack_public_path__ + "7f6934c59aba4aecd59fba331beb7aba.png";